import { useCallback } from 'react';

import { useAppDispatch } from '@verantos-dev/app-state-base';
import { datasetApiSlice as cohortAttritionApiSlice } from '@verantos-dev/data-access-cohort-attrition';
import { cohortSummaryApiSlice } from '@verantos-dev/data-access-cohort-summary';
import { subjectApiSlice } from '@verantos-dev/data-access-subjects';

export const useClearCohortResultsCache = (
  projectId?: string,
  cohortProfileId?: string
): {
  clearCohortResultsCache: () => void;
} => {
  const dispatch = useAppDispatch();

  const clearCohortResultsCache = useCallback(() => {
    if (!projectId || !cohortProfileId) {
      console.error('Project ID or cohort profile ID is not provided');
      return;
    }

    // Invalidate tags instead of upserting empty data.
    // This puts the queries into a "loading" state (isFetching=true, no stale data)
    // rather than an "empty data" state, preventing the UI from briefly showing
    // an empty table before the refetch completes.
    dispatch(
      cohortAttritionApiSlice.util.invalidateTags([
        { type: 'cohortAttrition', id: cohortProfileId },
      ])
    );

    dispatch(
      cohortSummaryApiSlice.util.invalidateTags([{ type: 'cohortSummary', id: cohortProfileId }])
    );

    dispatch(subjectApiSlice.util.invalidateTags([{ type: 'subjects', id: cohortProfileId }]));
  }, [projectId, cohortProfileId, dispatch]);

  return { clearCohortResultsCache };
};
